import { render, staticRenderFns } from "./SettingsElement.vue?vue&type=template&id=5d4a368a&scoped=true&lang=html"
import script from "./SettingsElement.vue?vue&type=script&lang=js"
export * from "./SettingsElement.vue?vue&type=script&lang=js"
import style0 from "./SettingsElement.vue?vue&type=style&index=0&id=5d4a368a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4a368a",
  null
  
)

export default component.exports